export const ConversionAssetTypes = Object.freeze({
  NONE: 'NONE',
  FORM: 'FORM',
  CTA: 'CTA'
});
export const ConversionAssetPositions = Object.freeze({
  PRE: 'PRE',
  POST: 'POST'
});